
import { UseModal } from '@/composable/useModal'
import QForm from 'quasar/src/components/form/QForm.js';
import { defineComponent, inject, ref } from 'vue'
import { required as requiredRule } from '@/common/formValidationRules'
import { hideDeviationVehicleProposal } from '@/api/deleted-deviation-vehicle-proposal/hideDeviationVehicleProposal'
import { DeviationVehicleProposal } from '@/types/deviation-vehicle-proposal'
import { v4 as uuidv4 } from 'uuid'
import { useDeviationVehicleProposal } from '@/composable/useDeviationVehicleProposal'

export default defineComponent({
  name: 'DeviationVehicleHideModal',

  setup() {
    const formModal = inject<UseModal<DeviationVehicleProposal>>(
      'deviation-vehicle-hide-modal'
    )
    const { data: deviationVehicleProposals } = useDeviationVehicleProposal()
    const formRef = ref<QForm | null>(null)
    const loading = ref(false)

    const comment = ref('')

    const onSubmit = async () => {
      const isValid = await formRef.value?.validate()
      if (!isValid || !formModal?.state?.data) return
      loading.value = true

      const body = {
        uuid: uuidv4(),
        advertised: formModal.state.data.advertised,
        departureDate: formModal.state.data.departureDate,
        from: formModal.state.data.from,
        to: formModal.state.data.to,
        comment: comment.value,
      }

      deviationVehicleProposals.value = deviationVehicleProposals.value.filter(
        (x) =>
          !(
            x.advertised === body.advertised &&
            x.departureDate === body.departureDate &&
            x.from === body.from &&
            x.to === body.to
          )
      )

      await hideDeviationVehicleProposal(body)

      loading.value = false
      formModal?.closeModal()
    }

    return {
      formModal,
      formRef,
      onSubmit,
      comment,
      loading,
      requiredRule,
    }
  },
})
